import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './InscriptionPage.css';

const InscriptionPage = () => {
  const [formData, setFormData] = useState({
    Firstname: '', Lastname: '', Company: '', Fonction: '', Email: '', Phone: '', RGPD: false
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      name: 'TR Inscriptions',
      data: {
        Firstname: formData.Firstname,
        Lastname: formData.Lastname,
        Company: formData.Company,
        Fonction: formData.Fonction,
        Email: formData.Email,
        Phone: formData.Phone,
        rgpd: formData.RGPD ? 'true' : 'false',
      },
    };

    try {
      const response = await fetch('https://flows.butterflyagency.io/webhook/webflow-forms-submisssion', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ triggerType: 'form_submission', payload }),
      });

      if (response.ok) {
        setSubmitted(true);
        setError(false);
      } else {
        setError(true);
      }
    } catch (err) {
      setError(true);
    }
  };

  return (
    <>
      <Helmet>
        <title>The Recap - Inscription événement</title>
        <meta name="description" content="Inscrivez-vous aux différents événements The Recap et recevez une restitution claire et actionnable des temps forts : tendances, innovations, stratégies retail et e-commerce." />
        <meta property="og:title" content="The Recap - Inscription événement" />
        <meta property="og:description" content="Inscrivez-vous aux différents événements The Recap et recevez une restitution claire et actionnable des temps forts : tendances, innovations, stratégies retail et e-commerce." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <section className="inscription-hero" style={{
        background: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${process.env.PUBLIC_URL}/images/hero-bg.png) center/cover no-repeat`
      }}>
        <div className="page-hero-overlay">
          <div className="page-hero-content">
            <img src="/images/logo-blanc.png" alt="THE RECAP Logo" className="page-hero-logo fade-in" />
            <h1 className="page-hero-title fade-in">Inscription</h1>
          </div>
        </div>
      </section>

      <section className="inscription-intro fade-in">
        <div className="inscription-container">
          <h2 className="inscription-subtitle">
            Les <strong>Dîners The Recap</strong> prolongent les <strong>Live</strong> à travers des rencontres exclusives en petit comité. Un format pensé pour approfondir les sujets clés, échanger entre pairs et créer des discussions à forte valeur ajoutée, dans un <strong>cadre privilégié</strong>.
          </h2>
        </div>
      </section>

      <section className="inscription-form-section">
        <div className="inscription-container">
          <h2 className="inscription-form-title">Les prochains dîners :</h2>
          <h3 className="inscription-form-subtitle">Inscription au prochain dîner du 11 juin 2026 à Paris</h3>
          <p className="inscription-note">Réservé aux retailers</p>

          {submitted ? (
            <div className="inscription-success fade-in">
              Merci ! Votre demande a bien été prise en compte ! Nous vous confirmerons rapidement la prise en compte de votre inscription.
            </div>
          ) : (
            <form className="inscription-form fade-in" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="Lastname" className="form-label">Nom</label>
                  <input type="text" id="Lastname" name="Lastname" className="form-input" value={formData.Lastname} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <label htmlFor="Firstname" className="form-label">Prénom</label>
                  <input type="text" id="Firstname" name="Firstname" className="form-input" value={formData.Firstname} onChange={handleChange} required />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="Company" className="form-label">Société</label>
                  <input type="text" id="Company" name="Company" className="form-input" value={formData.Company} onChange={handleChange} />
                </div>
                <div className="form-group">
                  <label htmlFor="Fonction" className="form-label">Fonction</label>
                  <input type="text" id="Fonction" name="Fonction" className="form-input" value={formData.Fonction} onChange={handleChange} />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="Email" className="form-label">Email Professionnel</label>
                <input type="email" id="Email" name="Email" className="form-input" value={formData.Email} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label htmlFor="Phone" className="form-label">Téléphone</label>
                <input type="tel" id="Phone" name="Phone" className="form-input" value={formData.Phone} onChange={handleChange} />
              </div>
              <div className="form-group form-checkbox-group">
                <input type="checkbox" id="RGPD" name="RGPD" className="form-checkbox" checked={formData.RGPD} onChange={handleChange} required />
                <label htmlFor="RGPD" className="form-checkbox-label">
                  En fournissant mes coordonnées, j'autorise les partenaires de THE RECAP à me contacter au sujet de ses produits et services via des communications personnalisées. Pour plus d'informations ou pour vous désinscrire à tout moment, contactez-nous à hello@the-recap.events
                </label>
              </div>
              {error && (
                <div className="inscription-error">Une erreur est survenue. Veuillez réessayer.</div>
              )}
              <button type="submit" className="btn-submit">S'inscrire</button>
            </form>
          )}

          <p className="inscription-disclaimer">
            *Cet événement est partiellement filmé. Si vous ne souhaitez pas être filmé(e), merci de le faire savoir à <a href="mailto:hello@the-recap.events">hello@the-recap.events</a>
          </p>
        </div>
      </section>
    </>
  );
};

export default InscriptionPage;
